import { CountryEnum } from '@systemeio/ui'
import { europeanCountries } from 'shared/enums/country-enum'

export const showSwitzerlandVatCheckbox = (userCountry: CountryEnum | null) => {
  if (userCountry) {
    return europeanCountries.includes(userCountry)
  }
  return false
}
